/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';

import { jsx } from '@compiled/react';

import { cssMap, type StrictXCSSProp } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		padding: token('space.150'),
		borderBlockStartWidth: token('border.width'),
		borderBlockStartStyle: 'solid',
		borderBlockStartColor: token('color.border'),
	},
});

/**
 * Footer slot component for the side nav.
 */
export const SideNavFooter = ({
	children,
	xcss,
}: {
	children: ReactNode;
	xcss?: StrictXCSSProp<'backgroundColor', never>;
}) => {
	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
		<div css={styles.root} className={xcss}>
			{children}
		</div>
	);
};
